import React, { useEffect, useState } from 'react';
import { getClients } from '../../lib/api';
import Marquee from 'react-fast-marquee';
import { useScrollReveal } from '../../hooks/useScrollReveal';

export default function ClientsSection() {
  const [clients, setClients] = useState([]);
  const sectionRef = useScrollReveal('.clients-reveal', { y: 20, duration: 0.6 });

  useEffect(() => {
    getClients().then(setClients).catch(console.error);
  }, []);

  if (!Array.isArray(clients) || clients.length === 0) return null;

  return (
    <section ref={sectionRef} data-testid="clients-section" className="py-12 bg-[#F5F7FA] border-y border-[#E1E7EF]">
      <div className="clients-reveal max-w-7xl mx-auto px-6 lg:px-12 mb-6">
        <p className="font-body text-sm font-medium text-[#585858] text-center">Trusted by leading companies</p>
      </div>
      <Marquee speed={30} gradient gradientColor="#F5F7FA" gradientWidth={60}>
        {clients.map((c) => (
          <div key={c.id} className="mx-10 flex items-center">
            {c.logo_url ? (
              <img src={c.logo_url} alt={c.name} className="h-8 opacity-50 hover:opacity-100 transition-opacity grayscale hover:grayscale-0" />
            ) : (
              <span className="font-heading font-bold text-lg text-[#1F1F1F]/25 hover:text-[#1F1F1F]/70 transition-colors">
                {c.name}
              </span>
            )}
          </div>
        ))}
      </Marquee>
    </section>
  );
}
